import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("iGMXi"), parcelRequire.load("g56vt"), parcelRequire.load("dsIXS"), parcelRequire.load("i0M0K"), parcelRequire.load("iwx79"), parcelRequire.load("6e0ex")]).then(() => {
let originalModule = parcelRequire("j5Ve0");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("iGMXi")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dsIXS")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("i0M0K")} />
  <link rel="modulepreload" href={parcelRequire.resolve("iwx79")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6e0ex")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
